import apiClient from '../lib/axios';

export interface MessageTemplate {
  id: string;
  key: string;
  label: string;
  template: string;
  variables: string[];
  updatedById?: string;
  createdAt: string;
  updatedAt: string;
}

class TemplateService {
  async getAll(): Promise<MessageTemplate[]> {
    const response = await apiClient.get('/templates');
    return response.data.data;
  }

  async update(id: string, template: string): Promise<MessageTemplate> {
    const response = await apiClient.put(`/templates/${id}`, { template });
    return response.data.data;
  }

  async resetToDefault(id: string): Promise<MessageTemplate> {
    const response = await apiClient.post(`/templates/${id}/reset`);
    return response.data.data;
  }

  async seed(): Promise<{ seeded: number }> {
    const response = await apiClient.post('/templates/seed');
    return response.data.data;
  }
}

export const templateService = new TemplateService();
